<template>
<!-- 常见问题 -->
    <div class="YinshiOffcialwebsiteCommonProblem">
        <div><el-button type="primary" size="small" @click="add">添加</el-button></div> 
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="question" label="问题标题" width="350"></el-table-column>
            <el-table-column prop="introduction" label="问题简介" ></el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scope" >
                    <el-button size="mini" @click="update(scope.row)">编辑</el-button>&ensp;
                    <el-popconfirm title="确定要删除吗？" icon="el-icon-info" icon-color="red" @confirm="deletes(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="sizes, prev, pager, next"
                    :total="count">
                </el-pagination>
            </div>
        </div>
        <el-dialog :title="title+'常见问题'" :visible.sync="dialogFormVisible" class="personalInfo" width="29%">
            <div class="recruit">
                <el-form :model="objData" ref="downloadObj">
                    <el-form-item label="问题标题" class="labelWidth">
                        <el-input v-model="objData.question" ></el-input>
                    </el-form-item>
                    <el-form-item label="问题简介" class="labelWidth">
                        <el-input v-model="objData.introduction" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUpdate">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// listFaq          查询常见问题
// deleteFaq        删除常见问题
// saveFaq          保存常见问题
// updataFaq        修改常见问题
import { 
listFaq,
deleteFaq,
saveFaq,
updataFaq,
} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteCommonProblem',
    data() {
        return {
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            // 总条数
            count:0,
            // 常见问题
            tableData: [],
            // 弹窗标题
            title:'',
            // 弹窗状态
            dialogFormVisible:false,
            // 要修改或者要增加
            objData:{
                introduction:'',//问题简介
                question:'',    //问题
                id:'',
            },
        };
    },

    mounted() {
        
    },
    watch:{
    },
    methods: {
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectTableData()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectTableData()
        },
        // 查询常见问题
        async selectTableData(){
            let res = await listFaq({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            this.tableData = res.data
        },
        // 删除
        async deletes(id){
            let res = await deleteFaq(id);
            if(res.code == 200){
                this.$message({ message: '删除成功！', type: 'success' });
                this.selectTableData()
            }else{
                this.$message({message: '删除失败！',type: 'error'});
            }
        },
        // 修改
        async update(obj){
            this.dialogFormVisible = true
            Object.keys(obj).forEach(key1 => {
                Object.keys(this.objData).forEach(key2 => {
                    if(key1 == key2){
                        this.objData[key2] = obj[key1] 
                    }
                })
            })
            this.title = '修改'
        },
        // 新增弹窗
        add(){
            Object.keys(this.objData).forEach(key => {
                this.objData[key] = ''
            })
            this.title = '新增'
            this.dialogFormVisible = true

        },
        // 提交修改
        async submitUpdate(){
            let res;
            if(this.title == '修改'){
                res = await updataFaq(this.objData);
            }else{  //新增
                res = await saveFaq(this.objData);
            }
            if(res.code == 200){
                this.$message({ message: this.title+'成功！', type: 'success' });
                this.selectTableData()
                this.dialogFormVisible = false
            }else{
                if(res.data){
                    this.$message({message: res.data+'！',type: 'error'});
                }else{
                    this.$message({message: this.title+''+res.msg+'！',type: 'error'});
                }
            }
        }
    },
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
        this.selectTableData()
    }
};
</script>

<style lang="scss">
.YinshiOffcialwebsiteCommonProblem .personalInfo .recruit{
    .el-form-item__label{
        width: 70px !important;
    }
    .el-form-item__content{
        width: 370px !important;
    }
    .el-dialog__body{
        padding: 10px 0px !important;
    }
}
</style>
<style lang="scss" scoped>
// 分页
.pagination{
    padding: 50px 270px 30px 270px;
    text-align: center;
}
</style>